import { useEffect, useRef, useState } from 'react'
// import Link from '~/components/atoms/Link/Link'
import { Link as ScrollLink } from 'react-scroll'

import classNames from 'classnames'

import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { useInPageNavContext } from '~/contexts/InPageNavContext'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import styles from './PageSubNavigation.module.css'

export interface PageSubNavigationProps {
  pageLinks: { title: string; link: string }[]
  testID?: string
  noBorder?: boolean
}

export default function PageSubNavigation({
  pageLinks,
  testID,
  noBorder = false,
}: PageSubNavigationProps) {
  const isMobile = useMediaQuery(`(max-width: ${bp.bpLarge})`)

  const [isElementTouchingTop, setIsElementTouchingTop] =
    useState<boolean>(false)

  const sectionsRef = useRef<Array<HTMLElement | null>>([])

  const [activeLink, setActiveLink] = useState(pageLinks?.[0]?.link || null)
  const [currentLink, setCurrentLink] = useState(pageLinks?.[0] || null)

  const { mainHeaderVisible } = useInPageNavContext()

  const filtersRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const elements: Array<HTMLElement | null> = []
    pageLinks.forEach(link => {
      const element = document.getElementById(link.link)
      if (element) {
        elements.push(element)
      }
    })

    sectionsRef.current = elements
  }, [pageLinks])

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY
      const sectionOffsets = sectionsRef.current.map(section => {
        return section ? section.offsetTop : 0
      })

      const offsetCalculation = isMobile ? -120 : 0

      const currentSectionIndex = sectionOffsets.findIndex(
        (offset, index) =>
          scrollPosition - offsetCalculation >= offset &&
          scrollPosition - offsetCalculation <
            (sectionsRef.current[index + 1]?.offsetTop ?? Infinity)
      )

      if (currentSectionIndex !== -1 && pageLinks[currentSectionIndex]) {
        setActiveLink(pageLinks[currentSectionIndex].link)
        setCurrentLink(pageLinks[currentSectionIndex])
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [pageLinks, isMobile])

  return (
    <>
      <div
        className={classNames(styles.base, {
          [styles.stuck]: isElementTouchingTop,
          [styles.mergeNav]: mainHeaderVisible,
          [styles.noBorder]: noBorder,
        })}
        data-testid={testID}
        ref={filtersRef}
      >
        <Container gutters={gutterTypes.always} cssClass={styles.container}>
          <div className={classNames(styles.inner)}>
            <div className={classNames(styles.scroller)}>
              <div className={classNames(styles.articleFilters)}>
                <div className={classNames(styles.linkContainer)}>
                  {pageLinks?.map((link, i) => (
                    <ScrollLink
                      className={styles.pageLinkItem}
                      smooth={true}
                      key={`page-item-link-${i}`}
                      tabIndex={i}
                      href={link.link ? `#${link.link}` : `#`}
                      to={link.link}
                      offset={isMobile ? -120 : 0}
                    >
                      <Text
                        size={TextSizes.primaryTitleXSml}
                        className={classNames({
                          [styles.active]: activeLink === link.link,
                        })}
                      >
                        {link.title}
                      </Text>
                    </ScrollLink>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}
